export const isPdfAttachment = (fileName: string): boolean => fileName.toLowerCase().endsWith('.pdf');

export const isImageAttachment = (fileName: string): boolean => /\.(jpe?g|png|gif|webp|bmp|svg)$/i.test(fileName);
